import { Component, OnInit } from '@angular/core';
import { Notification } from '../../../../core/Notifications/Notification';
import { ProfileService } from '../profile.service';
import { Router } from '@angular/router';
import { FormBuilder, FormControlName, FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NavbarService } from 'src/app/services/navbar.service';

@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.scss']
})
export class EditprofileComponent implements OnInit {
  selectedFiles: any;
  today=new Date();
  assetse = [];
  Image_Url;
  image: boolean;
  username;
  base64Image: any;
  testing: any;
  api:any;
  country: any;
  state: any;
  district: any;
  taluk: any;
  states: any;
  village: any;
  districtfilter: any;
  statefilter: any;
  talukfilter: any;
  villagefilter: any;
  gram: any;
  pincode: any;
  formValue: any;
  showDependentFields: boolean = false;
  relation: Object;
  constructor(private domSanitizer: DomSanitizer, private profileservice: ProfileService, private router: Router, private formBuilder: FormBuilder,
    private notify: Notification, private navbarservice:NavbarService) {
  }
  profileupdate = new FormGroup({
    PR_FirstName: new FormControl('',[Validators.pattern("^\\S{0}.{0,24}\\S{1}$"), Validators.required, this.nameValidatorss]),
    PR_LastName: new FormControl('',[Validators.pattern("^\\S{0}.{0,24}\\S{1}$"), Validators.required, this.nameValidatorss]),
    PR_Email: new FormControl('',[Validators.email]),
    PR_MobileNumber: new FormControl('',[Validators.pattern("[0-9]{10}$"), this.nameValidator, Validators.minLength(10), Validators.maxLength(10), Validators.required]),
    PR_Gender: new FormControl('',[Validators.required]),
    PR_DOB: new FormControl('',[Validators.required]),
    PR_Age: new FormControl('',[Validators.required]),
    PR_BloodGroup: new FormControl('',[Validators.required]),
    //PR_Gram_Id: new FormControl(''),
    PR_Village: new FormControl('',[Validators.pattern("^\\S{0}.{0,24}\\S{1}$"), this.nameValidatorss]),
    PR_Taluk_Id: new FormControl(''),
    PR_D_Id_FK: new FormControl(''),
    PR_S_Id_FK: new FormControl(''),
    PR_Country_Id_FK: new FormControl(''),
    PR_Postalcode: new FormControl('',[Validators.required,this.nameValidator]),
    UserId: new FormControl(''),
    PR_Id: new FormControl(''),
    pD_PR_Id_FK: new FormControl(''),
    PD_Id: new FormControl(0),
    PR_Photo:new FormControl(''),
    PD_Name: new FormControl('',[Validators.pattern("^\\S{0}.{0,24}\\S{1}$"), Validators.required, this.nameValidatorss]),
    PD_Gender: new FormControl('',[Validators.required]),
    PD_DOB: new FormControl('',[Validators.required]),
    PD_Age: new FormControl('',[Validators.required]),
    PD_Blood_Group: new FormControl('',[Validators.required]),
    PD_Relation_Id_FK: new FormControl(''),

  });
  selectFile(event) {
    this.selectedFiles = event.target.files;
    console.log(this.selectedFiles);
  }
  toggleDependentFields() {
    this.showDependentFields = !this.showDependentFields;
    if (!this.showDependentFields) {
      this.resetDependentValidators();
    } else {
      this.setDependentValidators();
    }
  }
  
  resetDependentValidators() {
    const controls = ['PD_Name', 'PD_Gender', 'PD_DOB', 'PD_Age', 'PD_Blood_Group', 'PD_Relation_Id_FK']; // Add more dependent fields as needed
  
    controls.forEach(controlName => {
      const control = this.profileupdate.get(controlName);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }
  
  setDependentValidators() {
    const controls = {
      'PD_Name': [Validators.pattern("^\\S{0}.{0,24}\\S{1}$"), Validators.required, this.nameValidatorss],
      'PD_Gender': [Validators.required],
      'PD_DOB': [Validators.required],
      'PD_Age': [Validators.required],
      'PD_Blood_Group': [Validators.required],
      'PD_Relation_Id_FK': [Validators.required]
    };
  
    for (const controlName in controls) {
      const control = this.profileupdate.get(controlName);
      if (control) {
        control.setValidators(controls[controlName]);
        control.updateValueAndValidity();
      }
    }
  }
  

  dobchange(event) {
    if (event.value) {
      const convertAge = new Date(event.value);
      const timeDiff = Math.abs(Date.now() - convertAge.getTime());
      const age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
      this.profileupdate.controls['PR_Age'].setValue(age)
    }
  }
  dobchange2(event) {
    if (event.value) {
      const convertAge = new Date(event.value);
      const timeDiff = Math.abs(Date.now() - convertAge.getTime());
      const age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
      this.profileupdate.controls['PD_Age'].setValue(age)
    }
  }
  onSelectFile(fileInput: any) {
    this.selectedFiles = <File>fileInput.target.files[0];
     var mimeType= this.selectedFiles.type
    //console.log('selected file type :',mimeType )
    //console.log('selected file :',this.selectedFiles )
    if (mimeType.match(/image\/*/) == null)
     {
			  //alert("Only images are supported");
        this.notify.errorsmsg("Please upload image only.");
        this.selectedFiles="";
        this.Image_Url="";
        this.profileupdate.controls['PR_Photo'].setValue("");
        return;
 
		}    

    
    var reader = new FileReader();
    reader.readAsDataURL(fileInput.target.files[0]);
    reader.onload = (event: any) => {
      this.base64Image = this.domSanitizer.bypassSecurityTrustUrl(event.target.result);
      this.Image_Url = this.base64Image
      //saheb
      this.navbarservice.changeUserImage(this.Image_Url)
      
    };
    
  }

  nameValidatorss(control: any): { [key: string]: boolean } {
    const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?/\/,/0-9]/;
    // const spaceexp: RegExp =/[/\s/g, '']/

    if (control.value && nameRegexp.test(control.value)) {
      return { invalidName: true };
    }
  }

  nameValidator(control: any): { [key: string]: boolean } {
    const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?/\s/g,''/a-zA-Z]/;
    // const spaceexp: RegExp =/[/\s/g, '']/

    if (control.value && nameRegexp.test(control.value)) {
      return { invalidName: true };
    }
  }


  ngOnInit(): void {
    if (!this.showDependentFields) {
      this.resetDependentValidators();
    } else {
      this.setDependentValidators();
    }
    this.get_relation();
    this.get_country();
    this.profileservice.get_Patientprofile()
      .subscribe((data: any) => {
        console.log('Patient profile:', JSON.stringify(data));       
        this.profileupdate.controls['PR_Id'].setValue(data.Id);
        this.profileupdate.controls['UserId'].setValue(data.UserId);
        this.profileupdate.controls['PR_FirstName'].setValue(data.Firstname);
        this.profileupdate.controls['PR_LastName'].setValue(data.Lastname);
        this.profileupdate.controls['PR_Email'].setValue(data.Email);
        this.profileupdate.controls['PR_MobileNumber'].setValue(data.Mobilenumber);
        this.profileupdate.controls['PR_Gender'].setValue(data.Gender);
        this.profileupdate.controls['PR_DOB'].setValue(data.DOB=="1900-01-01T00:00:00" ? '': data.DOB);
        this.profileupdate.controls['PR_Age'].setValue(data.Age);
        this.profileupdate.controls['PR_BloodGroup'].setValue(data.Bloodgroup);
        if(data.Country_Id_FK!=0)
        {
         this.get_state();
         this.get_district();
         this.get_taluk(); 
         this.profileupdate.controls['PR_Country_Id_FK'].setValue(data.Country_Id_FK);
         this.profileupdate.controls['PR_S_Id_FK'].setValue(data.State_Id_FK);
         this.profileupdate.controls['PR_D_Id_FK'].setValue(data.District_Id_FK);
         this.profileupdate.controls['PR_Taluk_Id'].setValue(data.Taluk_Id_FK);
        }
        this.profileupdate.controls['PR_Village'].setValue(data.Gram_name);
        this.profileupdate.controls['PR_Postalcode'].setValue(data.Postalcode);
        this.Image_Url = data.Photo;
        this.username = data.userName;
      })
  }
  select(data: any) {
    this.api = true;
  }
  saveForm() {
    if(this.profileupdate.invalid)
    {
      this.formValue=true
      return;
    }
    console.log(this.profileupdate.value)
    const formData = new FormData();
    const DOB = new DatePipe('en-US').transform(this.profileupdate.value.PR_DOB, 'dd/MM/yyyy')
    const DOB2 = new DatePipe('en-US').transform(this.profileupdate.value.PD_DOB, 'dd/MM/yyyy')
    formData.append('PR_FirstName', this.profileupdate.value.PR_FirstName);
    formData.append('PR_LastName', this.profileupdate.value.PR_LastName);
    formData.append('PR_Email', this.profileupdate.value.PR_Email);
    formData.append('PR_MobileNumber', this.profileupdate.value.PR_MobileNumber);
    formData.append('PR_Gender', this.profileupdate.value.PR_Gender);
    formData.append('PR_DOB', DOB);
    formData.append('PR_Age', this.profileupdate.value.PR_Age);
    formData.append('PR_BloodGroup', this.profileupdate.value.PR_BloodGroup);    
    formData.append('PR_Village', this.profileupdate.value.PR_Village);
    formData.append('PR_Taluk_Id', this.profileupdate.value.PR_Taluk_Id);
    formData.append('PR_D_Id_FK', this.profileupdate.value.PR_D_Id_FK);
    formData.append('PR_S_Id_FK', this.profileupdate.value.PR_S_Id_FK);
    formData.append('PR_Country_Id_FK', this.profileupdate.value.PR_Country_Id_FK);
    formData.append('PR_Postalcode', this.profileupdate.value.PR_Postalcode);
    formData.append('UserId', this.profileupdate.value.UserId);
    formData.append('PR_Id', this.profileupdate.value.PR_Id);
    formData.append('PR_Photo', this.selectedFiles);
    // formData.append('PD_Name', this.profileupdate.value.PD_Name);
    // formData.append('PD_Relation_Id_FK', this.profileupdate.value.PD_Relation_Id_FK);
    // formData.append('PD_Gender', this.profileupdate.value.PD_Gender);
    // formData.append('PD_DOB', DOB2);
    // formData.append('PD_Age', this.profileupdate.value.PD_Age);
    // formData.append('PD_Blood_Group', this.profileupdate.value.PD_Blood_Group);
    
    this.profileservice.update_profile(formData)
      .subscribe((res) => {
        console.log(res)
        this.notify.successmsg("Profile Updated Successfully");
        // window.location.reload();
        if (this.showDependentFields) {
          this.saveDependentDetails();
        } else {
          window.location.reload();
        }
      }, (error) => {
      }) 
  }

  saveDependentDetails() {
    const formData = new FormData();
    const DOB2 = new DatePipe('en-US').transform(this.profileupdate.value.PD_DOB, 'dd/MM/yyyy');
    // formData.append('PD_Id', this.profileupdate.value.pD_Id);
    formData.append('pD_PR_Id_FK', this.profileupdate.value.PR_Id);
    formData.append('PD_Name', this.profileupdate.value.PD_Name);
    formData.append('PD_Relation_Id_FK', this.profileupdate.value.PD_Relation_Id_FK);
    formData.append('PD_Gender', this.profileupdate.value.PD_Gender);
    formData.append('PD_DOB', DOB2);
    formData.append('PD_Age', this.profileupdate.value.PD_Age);
    formData.append('PD_Blood_Group', this.profileupdate.value.PD_Blood_Group);
    
    // this.profileservice.save_dependent_profile(formData)
    //   .subscribe((res) => {
    //     console.log(res);
    //     this.notify.successmsg("Dependent Details Updated Successfully");
    //     // window.location.reload();
    //   }, (error) => {
    //     this.notify.errorsmsg("Dependent Details Not Updated");
    //   });

    const pdId = this.profileupdate.value.PD_Id;
  if (pdId === 0) {
    console.log(JSON.stringify(formData));
    this.profileservice.save_dependent_profile(formData)
      .subscribe((res) => {
        console.log(res);
        this.notify.successmsg("Dependent Details Saved Successfully");
        window.location.reload();
      }, (error) => {
        this.notify.errorsmsg("Dependent Details Not Saved");
      });
  } else {
    formData.append('PD_Id', pdId);
    this.profileservice.update_dependent_profile(formData)
      .subscribe((res) => {
        console.log(res);
        this.notify.successmsg("Dependent Details Updated Successfully");
        window.location.reload();
      }, (error) => {
        this.notify.errorsmsg("Dependent Details Not Updated");
      });
  }
  }

  get_country(){
    this.profileservice.Get_country()
    .subscribe((data)=>{
      this.country=data
    })
  }
  get_relation(){
    this.profileservice.get_relation()
    .subscribe((data)=>{
      this.relation=data
    })
  }
  get_state(){
    this.profileservice.Get_state_f()
    .subscribe((data)=>{
      this.state=data
    })
  }
  
  get_district(){
    this.profileservice.Get_alldistrict()
    .subscribe((data)=>{
      this.district=data
    })
  }
  
  get_taluk(){
    this.profileservice.Get_allTaluk()
    .subscribe((data)=>{
      this.taluk=data
    })
  }
  
  get_gram(){
    this.profileservice.Get_allgram()
    .subscribe((data)=>{
      this.gram=data
    })
  }

  countrychange(event) {
    this.profileupdate.controls['PR_S_Id_FK'].reset();
    this.profileupdate.controls['PR_S_Id_FK'].updateValueAndValidity();
    this.profileupdate.controls['PR_D_Id_FK'].reset();
    this.profileupdate.controls['PR_D_Id_FK'].updateValueAndValidity();
    this.profileupdate.controls['PR_Taluk_Id'].reset();
    this.profileupdate.controls['PR_Taluk_Id'].updateValueAndValidity();
    this.gram = undefined
    this.taluk = undefined
    this.district = undefined
    this.state = undefined
    this.profileservice.Get_Statebyid(event)
      .subscribe((data) => {
        this.state = data
        if (this.state == '') {
          this.profileupdate.controls['PR_S_Id_FK'].setValue('');
          this.profileupdate.controls['PR_D_Id_FK'].setValue('');
          this.profileupdate.controls['PR_Taluk_Id'].setValue('');      

        }

        if (this.state.length == 0) {
          this.notify.errorsmsg("Data not found!");
        }
      })
  }
  statechange(event) {
    this.profileupdate.controls['PR_D_Id_FK'].reset();
    this.profileupdate.controls['PR_D_Id_FK'].updateValueAndValidity();
    this.profileupdate.controls['PR_Taluk_Id'].reset();
    this.profileupdate.controls['PR_Taluk_Id'].updateValueAndValidity();
    this.gram = undefined
    this.taluk = undefined
    this.district = undefined
    this.profileservice.Get_Districtbyid(event)
      .subscribe((data) => {
        this.district = data
      }, (error: any) => {

        this.profileupdate.controls['PR_D_Id_FK'].setValue('');
        this.profileupdate.controls['PR_Taluk_Id'].setValue('');
      });
  }

  distritchange(event) {
    this.profileupdate.controls['PR_Taluk_Id'].reset();
    this.profileupdate.controls['PR_Taluk_Id'].updateValueAndValidity();
    if (this.profileupdate.value.PR_D_Id_FK !== event) {
      this.profileupdate.controls['PR_Taluk_Id'].setValue('');
    }
    this.gram = undefined
    this.taluk = undefined

    this.gram = undefined
    this.taluk = undefined
    this.profileservice.Get_Talukbyid(event)

      .subscribe((data) => {
        this.taluk = data;


      });


  }
  testempty: any = [];
  gramData: any = [];
  talukchange(event) {
    if (this.profileupdate.value.PR_Taluk_Id !== event) {
      this.profileupdate.controls['PR_Village'].setValue(''); // Reset village selection
      this.profileupdate.controls['PR_Postalcode'].setValue(''); // Reset postal code
    }

    this.gram = undefined;
    this.profileservice.Get_Gram_id(event)
      .subscribe(
        (data) => {
          this.gram = data;
        },
        (error) => {
          this.gram = this.testempty;
        }
      );
  }
 

 selectpincode(gram_id){
  console.log(gram_id)
  // this.pincode=null
  this.pincode=this.gram.filter(x=>x.gram_id==gram_id)
  //console.log(this.pincode)
  this.profileupdate.controls['Postalcode'].setValue(this.pincode[0].postal_Code)

 }
  //state
  checkFilterCountry(data) {
    this.statefilter = this.state.filter(c => c.cntry_id == data.value);
    let stat_id = this.statefilter.stat_id;
    this.profileupdate.controls['pR_S_Id_FK'].setValue(stat_id);
  }
 //district
  checkFilterState(data) {
    this.districtfilter = this.district.filter(c => c.stat_id == data.value);
    let district_id = this.districtfilter.district_id;
    this.profileupdate.controls['pR_D_Id_FK'].setValue(district_id);
  }
  //taluk
  checkFilterDistrict(data) {
    this.talukfilter = this.taluk.filter(c => c.district_id == data.value);
    let taluk_id = this.talukfilter.taluk_id;
    this.profileupdate.controls['pR_Taluk_Id'].setValue(taluk_id);
  }
  //village
  checkFilterTaluk(data) {
    this.villagefilter = this.village.filter(c => c.taluk_id  == data.value);
    let gram_id = this.villagefilter.gram_id;
    this.profileupdate.controls['pR_Gram_Id'].setValue(gram_id);
  }

}